import { avatarRules } from "../../../../../arc/forms/avatar.js";

const jpegQuality = .92;

const createImage = src=>new Promise((resolve, reject)=>{
    const image = new Image();
    image.onload = _=>resolve(image);
    image.onerror = _=>reject(new Error("Image load failed."));
    image.src = src;
});

const toRadians = degrees=>degrees * Math.PI / 180;

const getRotatedSize = (width, height, rotation)=>{
    const radians = toRadians(rotation);
    return {
        width:Math.abs(Math.cos(radians) * width) + Math.abs(Math.sin(radians) * height),
        height:Math.abs(Math.sin(radians) * width) + Math.abs(Math.cos(radians) * height)
    };
};

const canvasToBlob = canvas=>new Promise((resolve, reject)=>{
    canvas.toBlob(blob=>{
        blob ? resolve(blob) : reject(new Error("Canvas export failed."));
    }, avatarRules.outputType, jpegQuality);
});

const getContext = canvas=>{
    const context = canvas.getContext("2d");
    if (!context) { throw new Error("Canvas context is not available."); }
    return context;
};

export const createAvatarFile = async (src, crop, rotation=0)=>{
    const image = await createImage(src);
    const width = image.naturalWidth || image.width;
    const height = image.naturalHeight || image.height;
    const box = getRotatedSize(width, height, rotation);
    const canvas = document.createElement("canvas");
    const context = getContext(canvas);

    canvas.width = box.width;
    canvas.height = box.height;
    context.translate(box.width / 2, box.height / 2);
    context.rotate(toRadians(rotation));
    context.translate(-width / 2, -height / 2);
    context.drawImage(image, 0, 0);

    const output = document.createElement("canvas");
    const outputContext = getContext(output);
    output.width = avatarRules.width;
    output.height = avatarRules.height;
    outputContext.fillStyle = "#101010";
    outputContext.fillRect(0, 0, avatarRules.width, avatarRules.height);
    outputContext.drawImage(canvas, crop.x, crop.y, crop.width, crop.height, 0, 0, avatarRules.width, avatarRules.height);

    const blob = await canvasToBlob(output);
    return new File([blob], avatarRules.outputName, { type:avatarRules.outputType, lastModified:Date.now() });
};
